import {Component, Input} from '@angular/core';
import {Section} from '@shared/services/hygraph/hygraph.models';
import { ScrollHelper } from '@app/@shared/utils/scroll-helper';

@Component({
    selector: 'app-hygraph-navigation',
    templateUrl: './hygraph-navigation.component.html',
    styleUrls: ['./hygraph-navigation.component.scss'],
    standalone: false
})
export class HygraphNavigationComponent {
  @Input() sections: Section[];
  @Input() createAnchorHref: (id: string) => string;

  public onClick(event: MouseEvent,  elementId: string): void {
    event.preventDefault();
    ScrollHelper.scrollToSection(elementId)
  }

  public hasNoContent(section: Section): boolean {
    return !section.sectionContent || !(section.sectionContent.length > 0);
  }

  public hasSubsections(section: Section): boolean {
    return section.subsections &&
        section.subsections.length > 0 &&
        section.subsections.filter(subsection => subsection.title).length > 0;
  }

  public allSubSectionsDisabled(section: Section): boolean {
    let isDisabled = true;
    if (section.subsections && section.subsections.length > 0) {
      let index = 0;
      while (isDisabled && index < section.subsections.length) {
        const subsection = section.subsections[index];
        isDisabled = this.hasNoContent(subsection);
        index ++;
      }
    } else {
      isDisabled = this.hasNoContent(section);
    }
    return isDisabled;
  }
}
